<template>
  <div id="geomagneticBusMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>定制报表</el-breadcrumb-item>
          <el-breadcrumb-item>地磁信息查询</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             class="pageSearch"
             label-width="80px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       filterable
                       :clearable="true"
                       placeholder="请选择客户"
                       @change="loadPark"
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <el-select v-model="pageSearch.fParkID"
                       filterable
                       placeholder="请选择场库"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in park_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地磁通道号::"
                        label-width="100px">
            <el-input placeholder="请输入两位的通道号"
                      v-model="pageSearch.fMagChnlNo"
                      style="width:200px;">
            </el-input>
          </el-form-item>

        </el-col>
        <el-col>
          <el-form-item label="车况状态::">
            <el-select v-model="pageSearch.fCarStatus"
                       clearable
                       filterable
                       placeholder="请选择车况状态"
                       style="width:200px;">
              <el-option v-for="item in carStatus_list"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="故障状态状态::">
            <el-select v-model="pageSearch.fExpStatus"
                       clearable
                       filterable
                       placeholder="请选择故障状态"
                       style="width:200px;">
              <el-option v-for="item in expStatus_list"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地磁关键信息::"
                        label-width="100px">
            <el-input placeholder="请输入通道名/IP/SN"
                      v-model="pageSearch.fSearchkeyword"
                      style="width:200px;">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="init">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success"
                       size="small"
                       v-if="is_export"
                       :loading="export_loading"
                       @click="exportData"
                       icon="el-icon-share">{{export_msg}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           align="right"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           label="客户编号"
                           width="80">
          </el-table-column>
          <el-table-column prop="fParkNo"
                           label="场库编号">
          </el-table-column>
          <el-table-column prop="fParkName"
                           label="场库名称">
          </el-table-column>
          <el-table-column prop="fMagIPAddr"
                           label="地磁网关IP">
          </el-table-column>
          <el-table-column prop="fMagChnlNo"
                           label="地磁通道号">
          </el-table-column>
          <el-table-column prop="fMagSN"
                           label="地磁设备SN">
          </el-table-column>
          <el-table-column prop="fMatVer"
                           label="程序版本">
          </el-table-column>
          <el-table-column prop="fRoadName"
                           label="地磁道路">
          </el-table-column>
          <el-table-column prop="fCarStatusName"
                           label="车况状态">
          </el-table-column>
          <el-table-column prop="fExpStatusName"
                           label="设备状态">
          </el-table-column>

          <el-table-column prop="fOpLastTime"
                           width="150"
                           label="最后传输时间">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10,20,100, 500, 1000]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { device as api } from '../../api/device'
import * as park from '../../api/park'
import * as user from '../../api/user'
export default {
  data () {
    // var validateIpPort = (rule, value, callback) => {
    //   if ((this.parkMagdev.fMagIPAddr || '').length > 0) {
    //     if (!/^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{4}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/.test(value)) {
    //       callback(new Error('请以IP:端口的形式填写'))
    //     }
    //   }
    //   callback()
    // }
    return {
      tableHeight: 0,
      export_loading: false,
      loading: false,
      is_export: false,
      export_msg: '导出',
      carStatus_list: [{ label: '无车', value: '0' }, { label: '有车', value: '1' }],
      expStatus_list: [{ label: '清除警报', value: '0' }, { label: '无线信号弱', value: '1' }, { label: '电池电量低', value: '2' }, { label: '断开连接', value: '3' }],
      dialogTitle: '',
      dialogVisible: false,
      pageData: [],
      cust_list: [],
      park_list: [],
      pageCount: 0,
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fParkID: '',
        fMagChnlNo: '',
        fMagIPAddr: '',
        fSearchkeyword: '',
        fCarStatus: '',
        fExpStatus: '',
        isExport: false

      }

    }
  },
  methods: {
    init (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }

      this.loading = true
      this.pageSearch.isExport = false
      api.geomagneticBusPageList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data || []
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    exportData () {
      if ((this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.cust_list || []).filter((item) => {
        return item.fCustID === this.pageSearch.fCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      this.pageSearch.isExport = true
      api.geomagneticBusPageList(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_地磁信息数据.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.init(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.init(val)
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 250
      obj.tableHeight = clientHeight
    },
    loadOptions () {
      park.getCustByGroup().then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data || []
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    },
    loadPark (fCustID) {
      this.pageSearch.fParkID = ''
      this.park_list = []
      // 加载在场数据列表
      // this.page_list()
      if (!fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.park_list = data.Data
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 78000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.loadOptions()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
/* dialog弹出框样式 */
#geomagneticBusMain .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#geomagneticBusMain .el-dialog__title {
  color: white;
}
#geomagneticBusMain .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#geomagneticBusMain .el-dialog__body {
  padding: 10px 10px;
}
#geomagneticBusMain .is-disabled .el-input__inner,
#geomagneticBusMain .is-disabled .el-textarea__inner {
  color: #606266;
}
#geomagneticBusMain .fRemark_item .el-form-item__content {
  height: auto;
}
#geomagneticBusMain .warning-row {
  color: #f56c6c;
}
</style>
<style scoped>
.add {
  text-align: right;
}
#geomagneticMain .rowsData {
  border: 1px solid #dcdfe6;
  padding: 5px;
  overflow: auto;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
#geomagneticMain .page-row {
  font-size: 16px;
}
#geomagneticMain .el-table__empty-text {
  font-size: 13px;
}
.search_list .t {
  color: #1eb1fb;
  font-weight: 700;
  min-height: 35px;
  line-height: 35px;
  font-size: 14px;
  padding: 0 7px;
}
#parkBaiduMap {
  float: left;
}
.road_item {
  margin-bottom: 0px;
}
.search_list .a {
  min-height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #666;
  padding: 0 7px;
}
.search_list {
  height: 300px;
  width: 30%;
  overflow-y: auto;
  float: left;
}
.search_list .el-row {
  margin-top: 0px;
}
.search_list .el-row.selected,
.search_list .el-row:hover {
  background: #dcd9d9;
  cursor: pointer;
}
.el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/report/geomagneticBusMain.vue